import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";
export default function* watcherGetSalesProductSaga() {
  yield takeEvery("LOAD_SALES_PRODUCT_LIST", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    if (action.payload.location > 0) {
      var formatUrl = `get-optimized-sales-products-by-location-and-category?LocationId=${action.payload.location
        }&CompanyId=${store.getState().persistReducer.companyId}&CategoryId=${action.payload.category
        }`;

      // var formatUrl = "get-all-sales-products-by-companyId";
      yield request("get", action.payload, formatUrl).then((response) => {
        payload = response;
      });
      yield put({ type: "SALES_PRODUCT_LIST", payload: payload });
      var payload = {};
      formatUrl =
        "api/Admin/get-categories-dropdown/" +
        store.getState().persistReducer.companyId;
      yield request("get", action.payload, formatUrl).then((response) => {
        payload = response;
      });
      yield put({ type: "PRODUCT_CATEGORY_DROPDOWN_LIST", payload: payload });
      formatUrl =
        "api/Admin/get-user-location-dropdown?userId=" +
        store.getState().persistReducer.userId;
      yield request("get", {}, formatUrl).then((response) => {
        payload = response;
      });
      yield put({ type: "LOCATIONS_LIST_DROPDOWN", payload: payload });
      formatUrl =
        "api/Admin/get-product-dropdown?id=" +
        store.getState().persistReducer.companyId;
      yield request("get", {}, formatUrl).then((response) => {
        payload = response;
      });
      console.log(payload)
      yield put({ type: "PRODUCT_DROPDOWN_LIST", payload: payload });

      yield put({ type: "DISPLAY_LOADER", payload: payload });
    }

  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
